<template>
  <Modal v-model="visible" title="请选择需要结算的数据" width="1400" class="my-modal top" :mask-closable="false" :footer-hide="true">
    <div class="search-box">
      <div class="input-item">
        <span class="label">推荐人机构</span>
        <Select
          v-model="formData.orgIds"
          :multiple="true"
          clearable
          :max-tag-count="1"
          :disabled="formData.groupIds && formData.groupIds.length ? true : false"
        >
          <Option v-for="(item, i) in orgList" :key="i" :value="item.id">{{ item.fullName }}</Option>
        </Select>
      </div>

      <div class="input-item">
        <span class="label">推荐人团队</span>
        <Select v-model="formData.recommendGroupIds" :multiple="true" clearable :max-tag-count="1">
          <Option v-for="(item, i) in groupList" :key="i" :value="item.groupId">{{ item.groupName }}-{{ item.groupCode }}</Option>
        </Select>
      </div>

      <div class="input-item">
        <span class="label">推荐人</span>
        <Select placeholder="请选择" v-model="formData.recommendOrgIds" clearable filterable>
          <Option v-for="(item, i) in userList" :key="i" :value="item.id">
            {{ item.name }}
          </Option>
        </Select>
      </div>

      <div class="input-item">
        <span class="label">被推荐人</span>
        <Select placeholder="请选择" v-model="formData.beRecommendedId" clearable filterable>
          <Option v-for="(item, i) in userList" :key="i" :value="item.id">
            {{ item.name }}
          </Option>
        </Select>
      </div>

      <div class="btn-item btn-box">
        <Button type="primary" @click="searchAjax">查询</Button>
        <Button type="primary" class="btn-reset" ghost @click="resetSearch">重置</Button>
      </div>
    </div>

    <!-- 工具栏 -->
    <div class="tools-box">
      <div class="left-box">
        <Checkbox v-model="isAll" @on-change="selectAll" :disabled="tableData.length ? false : true">全部</Checkbox>
      </div>
    </div>

    <div class="tableBox">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData" @on-selection-change="onSelectChange"> </Table>
      <Page
        :total="total"
        :current.sync="pageNum"
        :page-size="pageSize"
        show-total
        @on-change="getList"
        style="text-align: center; margin-top: 20px; margin-bottom: 60px"
      />
    </div>

    <div class="ivu-modal-footer">
      <Button type="primary" @click="ok" :loading="loading">加入结算</Button>
      <Button @click="visible = false">取消</Button>
    </div>
  </Modal>
</template>

<script>
import selectTree from '@/components/system/selectTree3';
import { pageTool, common } from '@/api/mixins';
export default {
  mixins: [pageTool, common],
  components: {
    selectTree
  },
  props: ['reportId'],
  data() {
    return {
      activityId: '',
      formData: {},
      visible: false,
      formData: {},
      total: null,
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '序号',
          type: 'index',
          width: 80,
          align: 'center'
        },
        {
          title: '推荐人',
          align: 'center',
          key: 'userName',
          minWidth: 90
        },
        {
          title: '推荐人手机号',
          align: 'center',
          key: 'recommendMobile',
          minWidth: 120
        },
        {
          title: '推荐人所属团队',
          align: 'center',
          key: 'recommendGroup',
          minWidth: 120
        },
        {
          title: '推荐人所属机构',
          align: 'center',
          key: 'recommendOrg',
          minWidth: 120
        },
        {
          title: '被推荐人',
          align: 'center',
          key: 'beRecommendedName',
          minWidth: 120
        },
        {
          title: '被推荐人手机号',
          align: 'center',
          key: 'beRecommendedMobile',
          minWidth: 120
        }
      ],
      total: null,
      tableData: [],
      isAll: false, //全部产品
      selectArr: [], //表格选择的数据
      loading: false,
      userList: [],
      groupList: [],
      orgList: [],
      orgIds: []
    };
  },
  methods: {
    open(activityId, orgIds) {
      this.visible = true;
      this.activityId = activityId;
      this.isAll = false;
      this.selectArr = [];
      this.orgList = [];
      this.formData.orgIds = orgIds;
      this.getOrgList(orgIds);
      this.queryGroupList();
      this.getUserList();
      this.searchAjax();
    },
    // 查询
    searchAjax() {
      this.pageNum = 1;
      this.getList();
    },
    // 重置
    resetSearch() {
      this.formData = {};
      this.searchAjax();
    },
    // 获取机构
    getOrgList(orgIds) {
      this.$http({
        url: '/buz/organizationBase/queryOrgs',
        type: 'POST',
        data: {
          ids: orgIds
        }
      }).then(res => {
        this.orgList = res.data;
      });
    },
    // 获取团队列表
    queryGroupList() {
      this.$http({
        url: '/buz/organizationGroup/getByOrgIds',
        type: 'POST',
        data: {
          organIds: this.formData.orgIds
        }
      }).then(res => {
        this.groupList = res.data;
      });
    },
    // 获取当前机构业务员
    getUserList() {
      this.$http({
        url: '/buz/userBase/getUserList',
        type: 'POST',
        data: {
          organizationIds: this.formData.orgIds,
          groupIds: this.formData.groupIds
        }
      }).then(res => {
        this.userList = res.data;
      });
    },
    getList() {
      this.listLoading = true;
      let data = JSON.parse(JSON.stringify(this.formData));
      this.$http({
        url: '/buz/merchantActivity/queryNeedSettlement',
        type: 'POST',
        data: {
          orgIds: this.formData.orgIds,
          pageNo: this.pageNum,
          pageSize: this.pageSize,
          ...data,
          activityId: this.activityId
        }
      })
        .then(res => {
          res.data.forEach(item => {
            this.selectArr.forEach(item2 => {
              if (item.activityId == item2.activityId) {
                item._checked = true;
              }
            });
            if (this.isAll) {
              item._checked = true;
              item._disabled = true;
            }
          });
          this.total = res.total;
          this.tableData = res.data;
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },
    // 全部选择
    selectAll(status) {
      const tableData = JSON.parse(JSON.stringify(this.tableData));
      tableData.forEach(item => {
        item._disabled = status;
        item._checked = status;
      });
      this.tableData = tableData;
      this.selectArr = [];
    },
    // 列表选中
    onSelectChange(curSelectArr) {
      const ids = curSelectArr.map(item => item.beRecommendedId); //当前页勾选的
      const selectIds = this.selectArr.map(item => item.beRecommendedId); //已经添加的数据
      this.tableData.forEach(item => {
        if (ids.includes(item.beRecommendedId) && !selectIds.includes(item.beRecommendedId)) {
          //未添加已勾选的数据时添加数据
          this.selectArr.push(item);
          selectIds.push(item.beRecommendedId);
        } else if (!ids.includes(item.beRecommendedId) && selectIds.includes(item.beRecommendedId)) {
          //添加了未勾选的数据时删除
          this.selectArr.splice(selectIds.indexOf(item.beRecommendedId), 1);
          selectIds.splice(selectIds.indexOf(item.beRecommendedId), 1);
        }
      });
    },
    ok() {
      if (!this.isAll && this.selectArr.length == 0) {
        this.$notice.alert('请至少选择一条数据');
        return;
      }

      let params = {};
      if (this.isAll) {
        params = {
          reportId: this.reportId,
          isAll: 1,
          merchantActivityRecommendVos: this.selectArr,
          merchantActivityRecommendQuery: {
            ...this.formData,
            activityId: this.activityId
          }
        };
      } else {
        params = {
          reportId: this.reportId,
          isAll: 0,
          merchantActivityRecommendVos: this.selectArr
        };
      }
      this.$http({
        url: '/buz/userSettlementData/saveData',
        type: 'POST',
        data: params
      }).then(res => {
        this.visible = false;
        this.$notice.success('加入结算成功');
        this.$emit('success');
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
